import Token from '../abis/Token.json'
import MeowDAO from '../abis/MeowDAO.json'
import { meow as meowDaoAddress, grumpy } from './Addresses';

export async function loadGrumpyContract(accounts) {
  const token = new window.web3.eth.Contract(Token.abi, grumpy)

  let tokenBalance = await token.methods.balanceOf(accounts[0]).call()

  return {
    contract: token,
    tokenBalance
  }
}

export async function loadMeowContract(accounts) {
  return {
    contract: new window.web3.eth.Contract(MeowDAO.abi, meowDaoAddress)
  };
}
